import type { TFunction } from 'i18next';

/**
 * Returns the client-type select options (individual / company).
 */
export function getClientTypeOptions(t: TFunction) {
  return [
    { value: 'individual' as const, label: t('form.labels.individual') },
    { value: 'company' as const, label: t('form.labels.company') },
  ];
}

/**
 * Returns the business-type select options.
 */
export function getBusinessTypeOptions(t: TFunction) {
  return [
    { value: 'sale', label: t('form.businessTypes.sale') },
    { value: 'rent', label: t('form.businessTypes.rent') },
    { value: 'exchange', label: t('form.businessTypes.exchange') },
    { value: 'both', label: t('form.businessTypes.both') },
    { value: 'short_term', label: t('form.businessTypes.short_term') },
  ];
}

/** `personal_info.gender` values (backend `GENDERS`). */
export const GENDER_VALUES = ['female', 'male', 'other', 'not_informed'] as const;

/** `personal_info.education` values (backend `EDUCATIONS`). */
export const EDUCATION_VALUES = ['elementary', 'high_school', 'higher', 'postgraduate'] as const;

/**
 * Origin channels a broker picks by hand on a new client. The capture
 * channels (site, portals, Meta, referral, import) are written by their own
 * flows and only ever shown.
 */
export const MANUAL_ORIGIN_CHANNELS = [
  'manual', 'vivareal', 'zap', 'imovelweb', 'chaves_na_mao', 'portal_imobiliarias',
  'mercado_livre', 'corretor_online', 'internet', 'sign', 'on_duty', 'storefront',
  'business_card', 'flyer', 'direct_mail', 'newspaper', 'active_prospecting', 'partnership',
] as const;

/**
 * Select options for a closed vocabulary, labelled through i18n.
 *
 * @param values - The stored values.
 * @param prefix - The i18n key prefix the labels live under.
 * @param t - Translator scoped to `features/clients`.
 * @returns The options in the given order.
 */
export function getVocabularyOptions(values: readonly string[], prefix: string, t: TFunction) {
  return values.map((value) => ({ value, label: t(`${prefix}.${value}`) }));
}
